import { Typography, TypographyProps } from "@mui/material"
import { CSSProperties } from "react"
import styled from "styled-components"

const StyledTitle = styled(Typography)`
    font-size:20px;
    margin:0;
    font-weight:400;
    color: var(--text_color_2);
`
const Title = (props: TypographyProps) => <StyledTitle variant="h6" {...props} >{props.children}</StyledTitle>

export const CARD_HEADING: CSSProperties = { textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }
export const CARD_HEADER: CSSProperties = { borderBottom: '1px solid #d8d8d8', display: 'flex', justifyContent: 'space-between', paddingBottom: '10px', alignItems: 'center' }
export const ERROR_HEADER: CSSProperties = { textAlign: 'center', color: 'red', margin: '10px 5px' }
export default Title